export default __webpack_public_path__ + "locales/az/About.json?hash=51a15e84cf89d0b286c7049b21b4e921";